import { TaskList } from "@/components/TaskList";
import { useDataProvider } from "@/providers/DataProvider";
import { Outlet } from "react-router-dom";
import { SectionHeader } from "@/components/SectionHeader";

export const HomePage = () => {
  const { tasks, categories, tags } = useDataProvider();

  return (
    <>
      <SectionHeader title="All Tasks" showAddTask={true} />
      <TaskList tasks={tasks} categories={categories} tags={tags} />
      <Outlet />
    </>
  );
};
